import React from "react";
import { AuthPage } from "../../auth/auth-page";

export const ResetPassword = () => <AuthPage view="forgot" />;
